import React, { useMemo } from 'react';
// `react-from-dom` `convert` docs: https://github.com/gilbarbara/react-from-dom
// for more information on how to do cleanup or validation with convert
import convert from 'react-from-dom';

const InlineSvgStr = React.memo(React.forwardRef((props, ref) => {
  const {
    svgStr = '',
    asset = svgStr,
    ...elementProps
  } = props;

  const reactElement = useMemo(() => {
    const svgNode = convert(asset, { nodeOnly: true });
    if (!svgNode || svgNode.nodeName.toLowerCase() !== 'svg') {
      return null;
    }

    // do any general purpose cleanup and tweaks that should apply to all SVGs
    svgNode.role = 'img';
    svgNode.ariaHidden = !svgNode.hasAttribute('aria-label');

    // return as a React Element
    return convert(svgNode);
  }, [asset]);

  return reactElement && React.cloneElement(reactElement, { ...elementProps, ref });
}));

export default InlineSvgStr;
